import React from 'react';

interface Props {
  liked?: boolean;
  label?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export function Heart({liked, label, size = 'medium'}: Props) {
  function heartStyles() {
    if (label) {
      return {
        fill: '#82898f',
        stroke: '#82898f',
      };
    }
    if (liked) {
      return {
        fill: '#E73756',
        stroke: '#E73756',
      };
    }
    return {
      fill: undefined,
      stroke: '#E73756',
    };
  }

  function heartSizeScale() {
    switch (size) {
      case 'small':
        return 1;
      case 'medium':
        return 1.5;
      case 'large':
        return 2;
    }
  }

  const scale = heartSizeScale();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${13 * scale}`}
      height={`${12 * scale}`}
      viewBox="-3 -1 14 12"
      fill="none"
      style={{display: 'block'}}
    >
      <path
        {...heartStyles()}
        d="M1.162 1.194h0c.864-.925 2.24-.925 3.104 0l.871.933.366.39.365-.39.866-.927h0c.865-.926 2.24-.926 3.104 0l.365-.341-.365.34c.883.946.883 2.478 0 3.422h0l-4.34 4.646-4.336-4.65v-.001c-.882-.946-.883-2.478 0-3.422z"
        opacity="0.778"
      ></path>
    </svg>
  );
}
